// extracted by mini-css-extract-plugin
export default {"faqDiv":"FAQ_faqDiv__0-izQ","grayInfo":"FAQ_grayInfo__V25z+"};